import { useMemo } from "react";
import FirmFlowTable from "../../../../components/mytasks/FirmFlowTable"; // Adjust the import path as necessary
import NewBadge from "../../../../components/NewBadge";
import ServiceDueDateCell from "../../../../components/reports/ServiceDueDateCell";
import { formatDate } from "../../../../helpers/formatDate";
import { sortDueDateRows } from "../../../../helpers/sortDueDateRows";
import {
    getReportStatusBadgeClass,
    getReportStatusLabel,
} from "../../../../helpers/reportStatusOptions";

const ServicesAccountabilityTable = ({ data, canReadServices = false, resetPageSignal }) => {
    const columns = useMemo(
        () => [
            {
                Header: "Department",
                accessor: "departmentName",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.id}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.row.original.isNew === true ? (
                            <span>
                                <NewBadge label="New" /> {props.value}
                            </span>
                        ) : (
                            props.value
                        )}
                    </a>
                ),
            },
            {
                Header: "Client",
                accessor: "clientName",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.id}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value}
                    </a>
                ),
            },
            {
                Header: "Service",
                accessor: "serviceName",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.id}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value}
                    </a>
                ),
            },
            {
                Header: "Assigend to",
                accessor: "assignedEmployee",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.id}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value != null
                            ? props.value.firstName + " " + props.value.lastName
                            : "Not Assigned"}
                    </a>
                ),
            },

            {
                Header: "Assigned Date",
                accessor: "subscriptionStartDate",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.id}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value
                            ? formatDate(props.value, {
                                  dateStyle: "short",
                              })
                            : "Not Assigned"}
                    </a>
                ),
            },
            {
                Header: "Due Date",
                accessor: "subscriptionEndDate",
                Cell: (props) => (
                    <ServiceDueDateCell
                        dueDate={props.value}
                        status={props.row.original.status}
                        dueDateColorClass={
                            props.row.original.dueDateColorClass
                        }
                        dueDateSubLabel={props.row.original.dueDateSubLabel}
                        completionLabel={props.row.original.completionLabel}
                        completionDate={props.row.original.completionDate}
                        href={`/clients/service/${props.row.original.serviceId}/client/${props.row.original.clientId}`}
                    />
                ),
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: (props) => {
                    const statusLabel = getReportStatusLabel(props.value);

                    return (
                        <a
                            rel="noreferrer"
                            href={`/clients/service/${props.row.original.serviceId}/client/${props.row.original.clientId}`}
                            className="inline-flex rounded-full whitespace-nowrap text-gray hover:text-blue-500"
                        >
                            <span
                                className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-sm font-medium text-white ${getReportStatusBadgeClass(
                                    props.value,
                                )}`}
                            >
                                {statusLabel}
                            </span>
                        </a>
                    );
                },
            },
            /*  {
                Header: "Notes",
                accessor: "notes",
                Cell: (props) => (
                    <p
                        onClick={() =>
                            onHandleClickNotes({
                                jobId: props.row.original.id,
                                notes: props.value,
                            })
                        }
                        className="rounded-full cursor-pointer text-gray hover:text-blue-500"
                    >
                        {props.value ? props.value : "Click to add notes"}
                    </p>
                ),
            }, */
        ],
        [],
    );
    const sortedData = useMemo(
        () =>
            sortDueDateRows(data, {
                dueDateKeys: ["subscriptionEndDate"],
                yearKeys: ["serviceYear", "year"],
                serviceNameKeys: ["serviceName", "service"],
            }),
        [data],
    );

    if (!canReadServices) return null;

    return (
        <div>
            {Array.isArray(data) && data.length > 0 ? (
                <FirmFlowTable
                    columns={columns}
                    data={sortedData}
                    resetPageSignal={resetPageSignal}
                />
            ) : (
                <p className="text-sm font-medium text-slate-500">
                    No services found for the selected filters.
                </p>
            )}
        </div>
    );
};

export default ServicesAccountabilityTable;
